import GtmTracker from '../lib/tracking/trackGtm';
import TrackingEventProcessor from '../lib/tracking/trackingEventProcessor';
// Self-guarding click trackers, folded in from former standalone packs. Each
// registers a DOMContentLoaded handler that no-ops when its DOM trigger is
// absent, so loading them globally with ua-tracking is safe.
import '../lib/tracking/mainCtaTracking';
import '../lib/tracking/contentTileTracking';
import '../lib/tracking/landingPageTracking';

const trailheadTrackEventListener = (trackerFns = []) => {
  const requireTrackerFn = () => {
    throw new Error('No tracker function passed');
  };

  if (trackerFns.length === 0) {
    requireTrackerFn();
  }

  const trackTrailheadEvent = (e) => {
    trackerFns.forEach((tracker) => tracker(e));
  };

  const attachEventListener = () => {
    document.addEventListener('trailhead_track', (e) => {
      trackTrailheadEvent(e);
    });
  };

  return {
    add: attachEventListener,
  };
};

if (process.env.NODE_ENV !== 'test') {
  const trailheadEventProcessor = new TrackingEventProcessor();
  const gtmTracker = new GtmTracker();
  const trackers = [trailheadEventProcessor.track, gtmTracker.track];
  trailheadTrackEventListener(trackers).add();
}

export default trailheadTrackEventListener;
